module.exports = __webpack_public_path__ + "static/media/icon-event__nuevos-populismos-el-auge-de-la-ultraderecha-hover.5a9a3597.svg";